import { Tooltip } from 'antd';
import React, { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { makeIsTaskCompletedSelector } from '../../../../../redux/tasks/taskEntities/selectors';
import { editTaskAction } from '../../../../../redux/tasks/actions';
import { useIntl } from 'react-intl';

const defaultFn = () => {};

const MarkCompleteButton = ({ isCompleted, taskId, readonly }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleTaskComplete = useCallback(() => {
    dispatch(editTaskAction({ _id: taskId, isCompleted: !isCompleted }));
  }, [isCompleted, taskId]);

  return (
    <div
      onClick={readonly ? defaultFn : handleTaskComplete}
      className="flex items-center justify-center"
    >
      <Tooltip
        title={
          readonly
            ? null
            : isCompleted
              ? intl.formatMessage({ id: 'MARK_INCOMPLETE', defaultMessage: 'Mark Incomplete' })
              : intl.formatMessage({ id: 'MARK_COMPLETE', defaultMessage: 'Mark Complete' })
        }
      >
        <div
          className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-150 ${
            readonly ? 'cursor-default' : 'cursor-pointer'
          } ${
            isCompleted
              ? 'bg-emerald-500 border-emerald-500'
              : 'border-gray-300 hover:border-emerald-400 bg-white hover:bg-emerald-50'
          }`}
        >
          {isCompleted && (
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="2,6 5,9 10,3" />
            </svg>
          )}
        </div>
      </Tooltip>
    </div>
  );
};

const makeMapStateToProps = () => {
  const isTaskCompletedSelector = makeIsTaskCompletedSelector();
  return (state, props) => ({
    isCompleted: props?.readonly ? props?.isCompleted : isTaskCompletedSelector(state, props),
  });
};

export default connect(makeMapStateToProps)(MarkCompleteButton);
